<template>
  <div class="topics-wrapper">
    <div class="container-fluid">
      <div class="header-row mb-2">
        <p class="section-title">
          MY PROGRESS
        </p>
      </div>

      <!-- progress boxes -->
      <b-row class="my-progress mb-3 gx-4 gy-3">
        <b-col
          v-for="box in progressBoxes"
          :key="box.label"
          cols="12"
          lg="4"
        >
          <b-card
            class="progress-box h-100"
            no-body
          >
            <div class="d-flex align-items-start">
              <div
                class="icon-wrapper mr-1"
                :style="{ background: box.bg }"
              >
                <feather-icon
                  :icon="box.icon"
                  size="22"
                />
              </div>
              <div>
                <small class="box-label">{{ box.label }}</small>
                <h3 class="mb-0 box-value">
                  {{ box.value }}
                </h3>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <!-- chart + users -->
      <b-row class="gx-4 gy-3 align-items-stretch">
        <b-col
          cols="12"
          lg="8"
        >
          <b-card
            class="chart-card h-100 pt-1"
            no-body
          >
            <div class="card-header d-flex justify-content-between">
              <div>
                <small>Progress time</small>
                <div class="chart-total fw-bold">
                  {{ totalSpentLabel }}ssssss
                </div>
              </div>
              <b-avatar
                size="34"
                class="chart-icon"
              >
                <feather-icon icon="BarChart2Icon" />
              </b-avatar>
            </div>

            <div class="chart-wrapper">
              <apexchart
                v-if="chartSeries && chartSeries.length"
                type="area"
                height="300"
                :options="chartOptions"
                :series="chartSeries"
              />
              <div
                v-else
                class="no-data"
              >
                No chart data
              </div>
            </div>
          </b-card>
        </b-col>

        <b-col
          cols="12"
          lg="4"
        >
          <b-card
            class="users-card h-100 d-flex flex-column"
            no-body
          >
            <div class="card-head pt-3 ml-3">
              <p>USERS</p>
            </div>

            <div class="users-list px-3 flex-grow-1">
              <div
                v-for="(u, idx) in usersDetails"
                :key="u.id || idx"
                class="user-row d-flex align-items-center mb-2"
              >
                <b-avatar
                  :src="u.avatar"
                  size="40"
                  class="mr-1"
                />
                <div class="flex-fill">
                  <div class="user-name">
                    {{ u.name }}
                  </div>
                  <div class="user-meta">
                    {{ u.status }} • {{ u.lastSeen }}
                  </div>
                </div>
              </div>

              <div
                v-if="!usersDetails.length"
                class="no-users text-muted"
              >
                No users yet
              </div>
            </div>

            <div class="p-3 text-right">
              <b-link
                class="view-all-link"
                @click.prevent="viewAllUsers"
              >
                View all <span>→</span>
              </b-link>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import {
  BAvatar, BCard, BRow, BCol, BLink,
} from 'bootstrap-vue'

export default {
  name: 'TopicsDashboard',
  components: {
    apexchart: VueApexCharts, BAvatar, BCard, BRow, BCol, BLink,
  },
  data() {
    return {
      usersDetails: [
        {
          id: 1,
          name: 'John Doe',
          status: 'online',
          avatar: 'https://via.placeholder.com/40',
          lastSeen: 'Today',
        },
        {
          id: 2,
          name: 'Jane Smith',
          status: 'offline',
          avatar: 'https://via.placeholder.com/40',
          lastSeen: 'Yesterday',
        },
      ],
    }
  },
  computed: {
    progressBoxes() {
      return [
        {
          label: 'All Experiments',
          value: 12,
          icon: 'PackageIcon',
          bg: 'linear-gradient(135deg, rgba(123,47,247,0.18), rgba(26,109,255,0.12))',
        },
        {
          label: 'Users',
          value: 50,
          icon: 'UsersIcon',
          bg: 'linear-gradient(135deg, rgba(37,78,158,0.18), rgba(70,124,227,0.12))',
        },
        {
          label: 'Active/License',
          value: '30/100',
          icon: 'ShieldIcon',
          bg: 'linear-gradient(135deg, rgba(52,211,153,0.12), rgba(16,185,129,0.08))',
        },
      ]
    },
    totalSpentLabel() {
      return '495 Hrs'
    },
    chartSeries() {
      return [
        {
          name: 'Spent',
          data: [170, 250, 220, 240, 210, 579, 180, 290, 120, 230, 150, 200],
        },
      ]
    },
    chartOptions() {
      return {
        chart: { toolbar: { show: false }, background: 'transparent' },
        stroke: { curve: 'smooth', width: 2 },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 0.6,
            gradientToColors: ['#0fd9de'],
            opacityFrom: 0.8,
            opacityTo: 0.05,
            stops: [0, 90, 100],
          },
        },
        markers: { size: 3, colors: ['#fff'], strokeColors: '#0fd9de' },
        xaxis: {
          labels: { show: false },
          axisBorder: { show: false },
          axisTicks: { show: false },
        },
        yaxis: {
          labels: { style: { colors: '#aaa', fontSize: '12px' } },
          axisBorder: { show: false },
        },
        grid: {
          show: true,
          borderColor: 'rgba(255,255,255,0.1)',
          strokeDashArray: 4,
          xaxis: { lines: { show: false } },
          yaxis: { lines: { show: true } },
        },
        tooltip: { theme: 'dark' },
        dataLabels: { enabled: false },
      }
    },
  },
  methods: {
    viewAllUsers() {
      this.$router.push({ name: 'users' }).catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
* {
  font-family: Montserrat;
}

.topics-wrapper {
  min-height: 100vh;
  background: linear-gradient(144deg, #1D133F 19%, #0E152B 41%, #12232F 87%);
  padding: 2.5rem 1rem;
  color: #fff;

  .section-title {
    font-size: 20px;
    margin-bottom: 1rem;
    opacity: 0.85;
  }

  .progress-box {
    height: 96px;
    border-radius: 14px;
    padding: 14px;
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.06);
    display: flex;
    align-items: center;
    flex-direction: row;
    .icon-wrapper {
      width: 56px;
      height: 56px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 20px;
      svg {
        stroke: #fff;
      }
    }
    .box-label {
      font-size: 13px;
      opacity: 0.8;
    }
    .box-value {
      font-size: 22px;
      margin-top: 6px;
    }
  }

  .chart-card {
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.06);
    .card-header {
      margin-bottom: 4px;
      small {
        opacity: 0.75;
      }
      .chart-total {
        font-size: 20px;
        font-weight: 700;
      }
    }
    .chart-wrapper {
      padding: 0;
    }
    .no-data {
      color: rgba(255, 255, 255, 0.6);
      height: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .users-card {
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.06);
    display: flex;
    flex-direction: column;

    .card-head {
      margin-bottom: 25px;
      p {
        font-size: 20px;
        opacity: 0.7;
      }
    }
    .users-list {
      flex-grow: 1;
      .user-row {
        svg {
          stroke: #fff;
        }
        .user-name {
          font-weight: 600;
        }
        .user-meta {
          font-size: 12px;
          opacity: 0.7;
        }
      }
      .no-users {
        opacity: 0.7;
      }
    }
    .view-all-link {
      font-size: 13px;
      span {
        color: #23c7ec !important;
      font-size: 15px;
      font-weight: 900;
      }
    }
  }
}
</style>
